"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TEMPLATE_LIBRARY_PERMISSIONS", {
    enumerable: true,
    get: function() {
        return TEMPLATE_LIBRARY_PERMISSIONS;
    }
});
const TEMPLATE_LIBRARY_PERMISSIONS = {
    viewLibrary: "template_library:viewLibrary",
    applyTemplate: "template_library:applyTemplate"
};
